// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import {StreamActions} from "@hotwired/turbo"
import * as coreui from "@coreui/coreui"

import "./controllers"
import "./font_awesome"
import "chartkick/chart.js"

StreamActions.redirect = function () {
    Turbo.visit(this.getAttribute("target"))
}
